export interface IPropesccoesListDto{
    sd43id: number,
    sd43codigo: string, 
    sd43cnpj: string, 
    sd43nome: string, 
    sd43na: string, 
    sd43situacao: number
}

export interface IListaProspeccoesDTO{
    count: number,
    values: Array<IPropesccoesListDto>
}

export interface ISd43Dto{
    sd43id?: number,
    sd43cnpj: string,
    sd43nome: string,
    sd43na: string,
    sd43ramoativ: string,
    sd43qtdefunc: number,
    sd43forma: number,
    sd43dtatualizacaosituacao: string,
    sd43situacao: number,
    sd43cep: string,
    sd43endereco: string,
    sd43numero: number,
    sd43bairro: string,
    sd43municipio: string,
    sd43uf: string,
    sd43complemento: string,
    sd43ddd1: string,
    sd43fone1: string,
    sd43ddd2: string,
    sd43fone2: string,
    sd43ddd3: string,
    sd43fone3: string,
    sd43email: string,
    sd43princinter: string,
    sd43obs: string,
    sd43du:string
    sd431s: Array<ISd431Dto>
    sd432s: Array<ISd432Dto>
    sd433s: Array<ISd433Dto>
}

export interface ISd431Dto{
    sd431id: number,
    sd431rep: {
        sd41id: number,
        sd41codigo: string,
        sd41nome: string,
    }
}

export interface ISd433Dto{
    sd433id: number,
    sd433data: string,
    sd433evento: string;
}

export interface ISd432Dto{
    sd432id: number,
    sd432codigo: number,
    sd432licencauso: number,
    sd432situacao: number
    sd432mensalidadecliente: number
}

export interface IEditarSd43Dto{
    sd43id?: number,
    sd43cnpj: string,
    sd43nome: string,
    sd43na: string,
    sd43ramoativ: string,
    sd43qtdefunc: number,
    sd43forma: number,
    sd43cep: string,
    sd43endereco: string,
    sd43numero: number,
    sd43bairro: string,
    sd43municipio: string,
    sd43uf: string,
    sd43complemento: string,
    sd43ddd1: string,
    sd43fone1: string,
    sd43ddd2: string,
    sd43fone2: string,
    sd43ddd3: string,
    sd43fone3: string,
    sd43email: string,
    sd43princinter: string,
    sd43obs: string,
}

export interface IProspeccaoSd41Dto{
    sd41id: number,
    sd41codigo: string,
    sd41nome: string,
}


export const converterSituacaoProspeccao = (sit: number) =>{
    const situacoes = {
        0: "Aberta",
        1: "Aguardando aprovação Proposta",
        2: "Proposta Aceita",
        3: "Contrato gerado",
        5: "Finalizada",
    }

    return situacoes[sit as keyof typeof situacoes];
}

export const converterSituacaoProposta = (sit: number) =>{
    const situacoes = {
        0: "Criada",
        1: "Aceita",
        2: "Não Aceita"
    }
    return situacoes[sit as keyof typeof situacoes];
}